<div class="_input flex flex-middle p-a-2 bg-col-52 p1">
    <input type="text"
           cy-searchInput
           [(ngModel)]="term"
           (keyup)="onInputKeyUp($event)"
           (focus)="onInputFocus()"
           #input
           class="flex-grow"
           [placeholder]="'What are you looking for?' | translate">
    <button [iconButton]
            [status]="status"
            cy-searchbutton
            #iconOn
            (click)="goToSearchView()"
            aria-label="Search"
            [icon]="'search'"></button>
</div>